<section class="content org-units-page">
  <div class="content-block org-units-page__content">
    <div class="block-header pb-2">
      <app-breadcrumb [title]="'MENUITEMS.ORGANIZATION.TEXT' | translate"
                      [items]="[('orgUnitsCatalog.breadcrumb' | translate)]"></app-breadcrumb>
    </div>


    <!-- <div class="container text-center">
        <div class="row">
    
          <div class="col align-self-start">
            <div class="org-units-page__hero-copy">
              <span class="org-units-page__eyebrow">{{ 'orgUnitsCatalog.hero.eyebrow' | translate }}</span>
              <h2 class="org-units-page__title">{{ 'orgUnitsCatalog.hero.title' | translate }}</h2>
            </div>
          </div>

          @if (companies.length > 1) {
          <div class="col">
            <mat-form-field subscriptSizing="dynamic" appearance="outline"
                            class="org-units-page__mat-field">
              <mat-label>{{ 'orgUnitsCatalog.fields.company' | translate }}</mat-label>
              <mat-select [(ngModel)]="selectedCompanyId"
                          (ngModelChange)="onCompanyChange()"
                          [disabled]="isLoadingCompanies || !companies.length">
                <mat-option value="">{{ 'orgUnitsCatalog.fields.selectCompany' | translate }}</mat-option>
                @for (company of companies; track trackByCompany($index, company)) {
                <mat-option [value]="company.companiesRecordId">
                  {{ company.name }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          }
          <div class="col">
            <mat-form-field subscriptSizing="dynamic" appearance="outline"
                            class="org-units-page__mat-field">
              <mat-label>{{ 'orgUnitsCatalog.fields.search' | translate }}</mat-label>
              <input matInput
                    [placeholder]="'orgUnitsCatalog.fields.searchPlaceholder' | translate"
                    [(ngModel)]="searchTerm"
                    (ngModelChange)="persistFilterState()"
                    [disabled]="!hasSelection || isLoadingOrgUnits" />
            </mat-form-field>
          </div>

          <div class="col">
            <button mat-stroked-button
                    type="button"
                    class="btn-tone-neutral org-units-page__refresh"
                    (click)="refresh()"
                    [disabled]="isLoadingCompanies || isLoadingOrgUnits">
              <mat-icon>refresh</mat-icon>
              {{ 'common.reload' | translate }}
            </button>
          </div>

        </div>
      </div> -->

    <div class="org-units-page__hero">
      <div class="card-body org-units-page__hero-body">
        <div class="org-units-page__toolbar"
             [class.org-units-page__toolbar--single-company]="companies.length <= 1">
          @if (companies.length > 1) {
          <div class="org-units-page__field org-units-page__field--company">
            <mat-form-field subscriptSizing="dynamic" appearance="outline" class="org-units-page__mat-field">
              <mat-icon matIconPrefix>apartment</mat-icon>
              <mat-label>{{ 'orgUnitsCatalog.fields.company' | translate }}</mat-label>
              <input matInput [placeholder]="'orgUnitsCatalog.fields.selectCompany' | translate"
                     [matAutocomplete]="companyAutocomplete" [(ngModel)]="companySearchTerm"
                     (ngModelChange)="handleCompanyInputChange($event)" autocomplete="off"
                     [disabled]="isLoadingCompanies || !companies.length" />
              @if (companySearchTerm) {
              <button mat-icon-button matSuffix type="button" (click)="clearCompanySearch()"
                      [attr.aria-label]="'common.clear' | translate"><mat-icon>close</mat-icon></button>
              }
              <mat-autocomplete #companyAutocomplete="matAutocomplete" [displayWith]="displayCompanyOption"
                                (opened)="handleCompanyAutocompleteOpened()"
                                (closed)="handleCompanyAutocompleteClosed()"
                                (optionSelected)="handleCompanyOptionSelected($event)">
                <mat-option value="__empty__">{{ 'orgUnitsCatalog.fields.selectCompany' | translate }}</mat-option>
                @for (company of filteredCompanies; track trackByCompany($index, company)) {
                <mat-option [value]="company">{{ company.name }}</mat-option>
                }
                @if (!filteredCompanies.length) {
                <mat-option disabled>{{ 'orgUnitsCatalog.empty.noMatchesTitle' | translate }}</mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>
          }

          <div class="org-units-page__field org-units-page__field--search">
            <mat-form-field subscriptSizing="dynamic" appearance="outline" class="org-units-page__mat-field">
              <mat-icon matIconPrefix>search</mat-icon>
              <mat-label>{{ 'orgUnitsCatalog.fields.search' | translate }}</mat-label>
              <input matInput [placeholder]="'orgUnitsCatalog.fields.searchPlaceholder' | translate"
                     [(ngModel)]="searchTerm" (ngModelChange)="persistFilterState()" autocomplete="off"
                     [disabled]="!hasSelection || isLoadingOrgUnits" />
              @if (searchTerm) {
              <button mat-icon-button matSuffix type="button" (click)="clearSearchTerm()"
                      [attr.aria-label]="'common.clear' | translate"><mat-icon>close</mat-icon></button>
              }
            </mat-form-field>
          </div>

          <button mat-stroked-button type="button"
                  class="btn-tone-neutral org-units-page__clear-action"
                  (click)="clearFilters()"
                  [disabled]="((companies.length <= 1 || !selectedCompanyId) && !searchTerm) || isLoadingCompanies || isLoadingOrgUnits">
            <mat-icon>filter_alt_off</mat-icon>
            {{ 'orgUnitsCatalog.actions.clearFilters' | translate }}
          </button>

          <button mat-stroked-button type="button"
                  class="btn-tone-neutral org-units-page__header-action"
                  (click)="refresh()"
                  [disabled]="isLoadingCompanies || isLoadingOrgUnits">
            <mat-icon>refresh</mat-icon>
            {{ 'common.reload' | translate }}
          </button>
        </div>
      </div>
    </div>

    <div class="org-units-page__workspace-switcher"
         role="tablist"
         [attr.aria-label]="'orgUnitsCatalog.breadcrumb' | translate">
      <button type="button"
              role="tab"
              [class.active]="workspaceView === 'tree'"
              [attr.aria-selected]="workspaceView === 'tree'"
              (click)="workspaceView = 'tree'">
        <mat-icon>account_tree</mat-icon>
        {{ 'orgUnitsCatalog.tree.title' | translate }}
        <span>{{ totalUnits }}</span>
      </button>
      <button type="button"
              role="tab"
              [class.active]="workspaceView === 'detail'"
              [attr.aria-selected]="workspaceView === 'detail'"
              [disabled]="!selectedOrgUnit && !isCreateMode"
              (click)="workspaceView = 'detail'">
        <mat-icon>dashboard</mat-icon>
        {{ 'orgUnitsCatalog.detail.title' | translate }}
      </button>
    </div>

    <div class="row g-2 org-units-page__workspace"
         [class.org-units-page__workspace--tree]="workspaceView === 'tree'"
         [class.org-units-page__workspace--detail]="workspaceView === 'detail'">
      <div class="col-xxl-5 col-xl-6 org-units-page__workspace-column">
        <div class="card org-panel">
          <div class="card-header org-panel__header">
            <div>
              <div class="org-panel__title-row">
                <h3 class="org-panel__title">{{ 'orgUnitsCatalog.tree.title' | translate }}</h3>
                <div class="org-panel__compact-stats">
                  <span [matTooltip]="'orgUnitsCatalog.stats.visibleUnits' | translate"
                        [attr.aria-label]="('orgUnitsCatalog.stats.visibleUnits' | translate) + ': ' + totalUnits">
                    <mat-icon>account_tree</mat-icon>
                    <strong>{{ totalUnits }}</strong>
                  </span>
                  <span [matTooltip]="'orgUnitsCatalog.stats.activeUnits' | translate"
                        [attr.aria-label]="('orgUnitsCatalog.stats.activeUnits' | translate) + ': ' + activeUnits">
                    <mat-icon>verified</mat-icon>
                    <strong>{{ activeUnits }}</strong>
                  </span>
                  <span [matTooltip]="'orgUnitsCatalog.stats.depth' | translate"
                        [attr.aria-label]="('orgUnitsCatalog.stats.depth' | translate) + ': ' + totalLevels">
                    <mat-icon>alt_route</mat-icon>
                    <strong>{{ totalLevels }}</strong>
                  </span>
                </div>
              </div>
              <p class="org-panel__subtitle">{{ 'orgUnitsCatalog.tree.description' | translate }}</p>
            </div>

            <div class="org-panel__actions">
              @if (canCreate) {
              <button mat-flat-button
                      type="button"
                      class="btn-tone-primary"
                      (click)="startCreate()"
                      [disabled]="!hasSelection || isSaving || isDeleting">
                <mat-icon>add</mat-icon>
                {{ 'orgUnitsCatalog.actions.create' | translate }}
              </button>
              }

              <!-- <div class="org-panel__chips">
                @for (summary of levelSummaries; track trackByLevel($index, summary)) {
                <span class="badge rounded-pill text-primary border border-primary-subtle bg-primary-subtle org-level-chip">
                  {{ getLevelLabel(summary.level) }} - {{ summary.count }}
                </span>
                }
              </div> -->
            </div>
          </div>

          <div class="card-body org-panel__body">
            @if (isLoadingCompanies || isLoadingOrgUnits) {
            <app-loading-state [overlay]="false"
                               [compact]="true"
                               [message]="'orgUnitsCatalog.loading' | translate"></app-loading-state>
            } @else if (!hasSelection) {
            <div class="org-empty-state">
              <mat-icon>account_tree</mat-icon>
              <h4>{{ 'orgUnitsCatalog.empty.selectCompanyTitle' | translate }}</h4>
              <p>{{ 'orgUnitsCatalog.empty.selectCompanyDescription' | translate }}</p>
            </div>
            } @else if (!filteredRoots.length) {
            <div class="org-empty-state">
              <mat-icon>search_off</mat-icon>
              <h4>{{ 'orgUnitsCatalog.empty.noMatchesTitle' | translate }}</h4>
              <p>{{ 'orgUnitsCatalog.empty.noMatchesDescription' | translate }}</p>
            </div>
            } @else {
            <div class="org-root-drop"
                 [class.org-root-drop--active]="isRootDropActive"
                 (dragover)="handleRootDragOver($event)"
                 (dragleave)="isRootDropActive = false"
                 (drop)="handleRootDrop($event)">
              <div class="org-root-drop__label">
                <mat-icon>device_hub</mat-icon>
                <strong>{{ 'orgUnitsCatalog.root' | translate }}</strong>
              </div>
              @if (selectedOrgUnitId) {
              <button mat-button
                      type="button"
                      class="org-root-drop__clear"
                      (click)="selectedOrgUnitId = ''; workspaceView = 'tree'; openViewMode()">
                {{ 'orgUnitsCatalog.actions.deselect' | translate }}
              </button>
              }
            </div>
            <div class="org-tree">
              <ng-container *ngTemplateOutlet="treeNodeTemplate; context: { $implicit: filteredRoots }"></ng-container>
            </div>
            }
          </div>
        </div>
      </div>

      <div class="col-xxl-7 col-xl-6 org-units-page__workspace-column">
        <div class="card org-panel org-panel--detail">
          <div class="card-header org-panel__header">
            <div>
              <h3 class="org-panel__title">{{ detailTitle }}</h3>
              <p class="org-panel__subtitle">{{ detailSubtitle }}</p>
            </div>

            @if (isCreateMode || isEditMode) {
            <div class="org-detail__actions">
              <button mat-flat-button
                      type="button"
                      class="btn-tone-primary"
                      (click)="save()"
                      [disabled]="isSaving || !isGeneralFormValid">
                <mat-icon>save</mat-icon>
                {{ isCreateMode ? ('orgUnitsCatalog.actions.saveUnit' | translate) : ('common.saveChanges' | translate) }}
              </button>
              <button mat-stroked-button
                      type="button"
                      class="btn-tone-neutral"
                      (click)="openViewMode()"
                      [disabled]="isSaving">
                {{ 'common.cancel' | translate }}
              </button>
            </div>
            } @else if (selectedOrgUnit && isViewMode) {
            <div class="org-detail__actions">
              @if (canUpdate) {
              <button mat-stroked-button
                      type="button"
                      class="btn-tone-primary"
                      (click)="startEdit()"
                      [disabled]="isSaving || isDeleting">
                <mat-icon>edit</mat-icon>
                {{ 'orgUnitsCatalog.actions.edit' | translate }}
              </button>
              }
              @if (canDelete) {
              <button mat-stroked-button
                      type="button"
                      class="btn-tone-danger"
                      (click)="deleteSelected()"
                      [disabled]="isSaving || isDeleting">
                <mat-icon>delete_outline</mat-icon>
                {{ 'common.delete' | translate }}
              </button>
              }
            </div>
            }
          </div>

          <div class="card-body org-panel__body">
            @if (selectedOrgUnit || isCreateMode || isEditMode) {
            <ul class="nav nav-tabs org-detail-tabs">
              <li class="nav-item">
                <button type="button"
                        class="nav-link rounded-pill"
                        [class.active]="activeDetailTab === 'general'"
                        (click)="selectDetailTab('general')">
                  <mat-icon>dashboard</mat-icon>
                  {{ 'orgUnitsCatalog.tabs.general' | translate }}
                </button>
              </li>
              <li class="nav-item">
                <button type="button"
                        class="nav-link rounded-pill"
                        [class.active]="activeDetailTab === 'configuration'"
                        (click)="selectDetailTab('configuration')">
                  <mat-icon>event_repeat</mat-icon>
                  {{ 'orgUnitsCatalog.tabs.configuration' | translate }}
                </button>
              </li>
              @if (!isCreateMode) {
              <li class="nav-item">
                <button type="button"
                        class="nav-link rounded-pill"
                        [class.active]="activeDetailTab === 'devices'"
                        (click)="selectDetailTab('devices')">
                  <mat-icon>devices</mat-icon>
                  {{ 'orgUnitsCatalog.tabs.devices' | translate }}
                </button>
              </li>
              }
              @if (!isCreateMode && canReadAttendanceConfig) {
              <li class="nav-item">
                <button type="button"
                        class="nav-link rounded-pill"
                        [class.active]="activeDetailTab === 'attendanceConfiguration'"
                        (click)="selectDetailTab('attendanceConfiguration')">
                  <mat-icon>fingerprint</mat-icon>
                  {{ 'attendanceConfigsCatalog.tabLabel' | translate }}
                </button>
              </li>
              }
              @if (selectedOrgUnit && (isViewMode || isEditMode)) {
              <li class="nav-item">
                <button type="button"
                        class="nav-link rounded-pill"
                        [class.active]="activeDetailTab === 'users'"
                        (click)="selectDetailTab('users')">
                  <mat-icon>group</mat-icon>
                  {{ 'orgUnitsCatalog.tabs.users' | translate }}
                </button>
              </li>
              }
            </ul>
            }

            @if (isCreateMode || isEditMode) {
            <div class="org-form">
              @if (activeDetailTab === 'general') {
              <div class="org-form__group">
                <app-company-select [records]="companies" [value]="form.companiesRecordId"
                                    [label]="'orgUnitsCatalog.fields.company' | translate"
                                    [placeholder]="'orgUnitsCatalog.fields.company' | translate"
                                    [disabled]="isEditMode || isSaving"
                                    (valueChange)="form.companiesRecordId = $event; onFormCompanyChange()" />
              </div>

              <div class="org-form__group">
                <mat-form-field subscriptSizing="dynamic"
                                appearance="outline">
                  <mat-label>{{ 'orgUnitsCatalog.fields.name' | translate }}</mat-label>
                  <input matInput
                         [(ngModel)]="form.name"
                         required
                         [disabled]="isSaving"
                         [placeholder]="'orgUnitsCatalog.fields.namePlaceholder' | translate" />
                </mat-form-field>
              </div>

              <div class="org-form__group">
                <mat-form-field subscriptSizing="dynamic"
                                appearance="outline">
                  <mat-label>{{ 'orgUnitsCatalog.fields.code' | translate }}</mat-label>
                  <input matInput
                         class="org-form__code-input"
                         [ngModel]="form.code"
                         (ngModelChange)="onOrgUnitCodeInput($event)"
                         data-preserve-case="true"
                         data-lowercase="true"
                         [disabled]="isSaving"
                         maxlength="80"
                         autocomplete="off"
                         [placeholder]="'orgUnitsCatalog.fields.codePlaceholder' | translate" />
                  <button type="button"
                          mat-icon-button
                          matSuffix
                          tabindex="-1"
                          [attr.aria-label]="'orgUnitsCatalog.fields.codeTooltip' | translate"
                          [matTooltip]="'orgUnitsCatalog.fields.codeTooltip' | translate">
                    <mat-icon>info_outline</mat-icon>
                  </button>
                </mat-form-field>
              </div>

              <div class="org-form__group">
                <mat-form-field subscriptSizing="dynamic"
                                appearance="outline">
                  <mat-label>{{ 'orgUnitsCatalog.fields.type' | translate }}</mat-label>
                  <input matInput
                         [(ngModel)]="form.type"
                         required
                         [matAutocomplete]="typeAutocomplete"
                         (ngModelChange)="onOrgUnitTypeInput($event)"
                         [disabled]="isSaving"
                         autocomplete="off"
                         [placeholder]="'orgUnitsCatalog.fields.typePlaceholder' | translate" />
                  <mat-icon matSuffix>arrow_drop_down</mat-icon>
                  <mat-autocomplete #typeAutocomplete="matAutocomplete"
                                    (opened)="onOrgUnitTypeAutocompleteOpened()">
                    @for (typeOption of orgUnitTypeOptions; track typeOption) {
                    <mat-option [value]="typeOption">{{ typeOption }}</mat-option>
                    }
                    @if (!isLoadingTypeOptions && !orgUnitTypeOptions.length) {
                    <mat-option disabled>{{ 'orgUnitsCatalog.fields.typeNoOptions' | translate }}</mat-option>
                    }
                  </mat-autocomplete>
                </mat-form-field>
              </div>

              <div class="org-form__group org-form__group--wide">
                <mat-form-field subscriptSizing="dynamic"
                                appearance="outline">
                  <mat-label>{{ 'orgUnitsCatalog.fields.parentUnit' | translate }}</mat-label>
                  <mat-select [(ngModel)]="form.parentId"
                              [disabled]="isSaving">
                    <mat-option [value]="null">{{ 'orgUnitsCatalog.root' | translate }}</mat-option>
                    @for (parent of parentOptions; track trackByNode($index, parent)) {
                    <mat-option [value]="parent.orgUnitId">{{ parent.name }} - {{ getLevelLabel(parent.level) }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              } @else {
              @if (activeDetailTab === 'configuration') {
              <div class="org-form__footer org-work-assignment">
                <div class="org-work-assignment__heading">
                  <div class="org-units-page__config-toggle">
                    <h6 class="m-0">{{ 'orgUnitsCatalog.workAssignment.enabled' | translate }}</h6>
                    <mat-slide-toggle class="small-toggle"
                                      [(ngModel)]="workAssignmentForm.enabled"
                                      [disabled]="isSaving"
                                      (ngModelChange)="onWorkAssignmentToggle()">
                    </mat-slide-toggle>
                  </div>

                  <div class="org-units-page__inheritance-banner"
                       [class.org-units-page__inheritance-banner--own]="isWorkAssignmentOwn">
                    <mat-icon>{{ isWorkAssignmentOwn ? 'tune' : 'account_tree' }}</mat-icon>
                    <div>
                      <span>{{ (isWorkAssignmentOwn ? 'operationalConfigInheritance.ownLabel' : 'operationalConfigInheritance.inheritedLabel') | translate }}</span>
                      <strong>{{ workAssignmentOriginLabel }}</strong>
                      @if (!workAssignmentForm.enabled) {
                      <small>{{ 'operationalConfigInheritance.enableToOverride' | translate }}</small>
                      }
                    </div>
                  </div>
                </div>

                <div class="row g-3 mb-2 attendance-config-layout org-work-assignment__fields">
                  <div class="col-12 col-md-6">
                    <mat-form-field subscriptSizing="dynamic"
                                    appearance="outline">
                      <mat-label>{{ 'orgUnitsCatalog.workAssignment.workCycleId' | translate }}</mat-label>
                      <mat-select [(ngModel)]="workAssignmentForm.workCycleId"
                                  [disabled]="isSaving || !workAssignmentForm.enabled || isLoadingWorkCycles"
                                  (ngModelChange)="onWorkCycleChange()">
                        <mat-option value="">{{ 'common.select' | translate }}</mat-option>
                        @for (cycle of workCycles; track cycle.workCycleId) {
                        <mat-option [value]="cycle.workCycleId">{{ cycle.name }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div class="col-12 col-md-6">
                    <mat-form-field subscriptSizing="dynamic"
                                    appearance="outline">
                      <mat-label>{{ 'orgUnitsCatalog.workAssignment.restConfigurationId' | translate }}</mat-label>
                      <mat-select [(ngModel)]="workAssignmentForm.restConfigurationId"
                                  [disabled]="isSaving || !workAssignmentForm.enabled">
                        <mat-option value="">{{ 'common.select' | translate }}</mat-option>
                        @for (restConfiguration of restConfigurations; track restConfiguration.restConfigurationId) {
                        <mat-option [value]="restConfiguration.restConfigurationId">{{ restConfiguration.name }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <!-- Cycle offset is intentionally hidden until offset-based assignments are enabled again. -->
                  <div class="col-12">
                    <div class="row g-3">
                      <div class="col-12 col-md-4">
                        <app-date-time-picker-field [label]="'orgUnitsCatalog.workAssignment.cycleStartDate' | translate"
                                                    [value]="workAssignmentForm.cycleStartDate"
                                                    mode="date"
                                                    [required]="true"
                                                    [disabled]="isSaving || !workAssignmentForm.enabled"
                                                    (valueChange)="onWorkAssignmentDateChange('cycleStartDate', $event)">
                        </app-date-time-picker-field>
                      </div>

                      <div class="col-12 col-md-4">
                        <app-date-time-picker-field [label]="'orgUnitsCatalog.workAssignment.effectiveFrom' | translate"
                                                    [value]="workAssignmentForm.effectiveFrom"
                                                    mode="date"
                                                    [disabled]="isSaving || !workAssignmentForm.enabled"
                                                    (valueChange)="onWorkAssignmentDateChange('effectiveFrom', $event)">
                        </app-date-time-picker-field>
                      </div>

                      <div class="col-12 col-md-4">
                        <app-date-time-picker-field [label]="'orgUnitsCatalog.workAssignment.effectiveTo' | translate"
                                                    [placeholder]="'orgUnitsCatalog.workAssignment.openEnded' | translate"
                                                    [value]="workAssignmentForm.effectiveTo"
                                                    mode="date"
                                                    [disabled]="isSaving || !workAssignmentForm.enabled"
                                                    (valueChange)="onWorkAssignmentDateChange('effectiveTo', $event)">
                        </app-date-time-picker-field>
                      </div>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="employees-detail-page__section-card">
                      <div class="employees-detail-page__section-header">
                        <h6>{{ 'workAssignmentRules.title' | translate }}</h6>
                        <p>{{ 'workAssignmentRules.description' | translate }}</p>
                      </div>

                      <div class="row g-3">
                        <div class="col-12 col-md-6 col-xl-3">
                          <mat-form-field subscriptSizing="dynamic"
                                          appearance="outline">
                            <mat-label>{{ 'workAssignmentRules.entryToleranceMinutes' | translate }}</mat-label>
                            <input matInput
                                   type="number"
                                   min="0"
                                   step="1"
                                   [(ngModel)]="workAssignmentForm.toleranceRules.entryToleranceMinutes"
                                   [disabled]="isSaving || !workAssignmentForm.enabled" />
                          </mat-form-field>
                        </div>

                        <div class="col-12 col-md-6 col-xl-3">
                          <mat-form-field subscriptSizing="dynamic"
                                          appearance="outline">
                            <mat-label>{{ 'workAssignmentRules.earlyExitToleranceMinutes' | translate }}</mat-label>
                            <input matInput
                                   type="number"
                                   min="0"
                                   step="1"
                                   [(ngModel)]="workAssignmentForm.toleranceRules.earlyExitToleranceMinutes"
                                   [disabled]="isSaving || !workAssignmentForm.enabled" />
                          </mat-form-field>
                        </div>

                        <div class="col-12 col-md-6 col-xl-3">
                          <mat-form-field subscriptSizing="dynamic"
                                          appearance="outline">
                            <mat-label>{{ 'workAssignmentRules.roundingMarginMinutes' | translate }}</mat-label>
                            <input matInput
                                   type="number"
                                   min="0"
                                   step="1"
                                   [(ngModel)]="workAssignmentForm.toleranceRules.roundingMarginMinutes"
                                   [disabled]="isSaving || !workAssignmentForm.enabled" />
                          </mat-form-field>
                        </div>

                        <div class="col-12 col-md-6 col-xl-3 d-flex align-items-center">
                          <mat-slide-toggle [(ngModel)]="workAssignmentForm.overtimePolicy.ignoreOvertime"
                                            [disabled]="isSaving || !workAssignmentForm.enabled">
                            {{ 'workAssignmentRules.ignoreOvertime' | translate }}
                          </mat-slide-toggle>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="employees-detail-page__section-card">
                      <div class="employees-detail-page__section-header">
                        <h6>{{ 'orgUnitsCatalog.workAssignment.cyclePreview.title' | translate }}</h6>
                        <p>{{ 'orgUnitsCatalog.workAssignment.cyclePreview.description' | translate }}</p>
                      </div>

                      @if (assignmentSelectedScheduleMonth; as scheduleMonth) {
                      <div class="employees-detail-page__cycle-calendar">
                        <div class="employees-detail-page__cycle-calendar-toolbar">
                          <button mat-icon-button
                                  type="button"
                                  [disabled]="!hasPreviousAssignmentScheduleMonth"
                                  (click)="showPreviousAssignmentScheduleMonth()">
                            <mat-icon>chevron_left</mat-icon>
                          </button>

                          <strong class="employees-detail-page__cycle-calendar-title">{{ scheduleMonth.label }}</strong>

                          <button mat-icon-button
                                  type="button"
                                  [disabled]="!hasNextAssignmentScheduleMonth"
                                  (click)="showNextAssignmentScheduleMonth()">
                            <mat-icon>chevron_right</mat-icon>
                          </button>
                        </div>

                        <div class="employees-detail-page__cycle-planner-head">
                          @for (weekday of assignmentWeekdayLabels; track weekday) {
                          <div class="employees-detail-page__cycle-planner-head-cell">{{ weekday }}</div>
                          }
                        </div>

                        <div class="employees-detail-page__cycle-planner-weeks">
                          @for (week of [0, 1, 2, 3, 4, 5]; track week) {
                          <div class="employees-detail-page__cycle-planner-week">
                            @for (day of scheduleMonth.days.slice(week * 7, (week + 1) * 7); track $index) {
                            <article class="employees-detail-page__cycle-planner-cell"
                                     [class.employees-detail-page__cycle-planner-cell--outside]="!day.isCurrentMonth"
                                     [class.employees-detail-page__cycle-planner-cell--rest]="day.previewDay?.isRest"
                                     [class.employees-detail-page__cycle-planner-cell--range]="day.isInRange"
                                     [class.employees-detail-page__cycle-planner-cell--start]="day.isStart"
                                     [class.employees-detail-page__cycle-planner-cell--end]="day.isEnd">
                              <div class="employees-detail-page__cycle-planner-cell-top">
                                <strong class="employees-detail-page__cycle-planner-date">{{ day.dayNumber }}</strong>
                                @if (day.previewDay) {
                                <span class="employees-detail-page__cycle-planner-order">
                                  {{ 'orgUnitsCatalog.workAssignment.cyclePreview.day' | translate:{ day: day.previewDay.dayOrder } }}
                                </span>
                                }
                              </div>

                              @if (day.previewDay) {
                              <div class="employees-detail-page__cycle-planner-body">
                                <span class="employees-detail-page__cycle-planner-weekday">{{ day.weekdayLabel }}</span>
                                <strong class="employees-detail-page__cycle-planner-range">{{ day.previewDay.scheduleRange }}</strong>
                                <span class="employees-detail-page__cycle-planner-name">{{ day.previewDay.scheduleName }}</span>
                                <small class="employees-detail-page__cycle-planner-hours">{{ day.previewDay.expectedHours }}</small>
                              </div>
                              } @else {
                              <div class="employees-detail-page__cycle-planner-body employees-detail-page__cycle-planner-body--empty">
                                <span class="employees-detail-page__cycle-planner-muted">
                                  {{ 'orgUnitsCatalog.workAssignment.cyclePreview.outsideRange' | translate }}
                                </span>
                              </div>
                              }
                            </article>
                            }
                          </div>
                          }
                        </div>
                      </div>
                      } @else {
                      <div class="employees-detail-page__cycle-preview-empty">
                        <mat-icon>event_busy</mat-icon>
                        <span>{{ 'orgUnitsCatalog.workAssignment.cyclePreview.empty' | translate }}</span>
                      </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
              } @else if (activeDetailTab === 'devices' && !isCreateMode) {
              <div class="org-form__footer"
                   style="width: 100%;">
                <div class="org-form__group"
                     style="width: 100%;">
                  <mat-form-field subscriptSizing="dynamic"
                                  appearance="outline"
                                  class="w-100">
                    <mat-label>{{ 'devicesCatalog.breadcrumb' | translate }}</mat-label>
                    <mat-select [(ngModel)]="selectedDeviceIds"
                                multiple>
                      @for (device of devices; track device.deviceId) {
                      <mat-option [value]="device.deviceId">
                        {{ device.name || device.serial }} @if (device.serial) {<span>({{ device.serial }})</span>}
                      </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              } @else if (activeDetailTab === 'attendanceConfiguration' && !isCreateMode && canReadAttendanceConfig) {
              <div class="org-form__footer org-work-assignment">
                <div class="org-work-assignment__heading"
                     [class.org-work-assignment__heading--status-only]="!canManageAttendanceConfig">
                  @if (canManageAttendanceConfig) {
                  <div class="org-units-page__config-toggle">
                    <h6 class="m-0">{{ 'attendanceConfigsCatalog.enabled' | translate }}</h6>
                    <mat-slide-toggle class="small-toggle"
                                      [(ngModel)]="attendanceConfigForm.enabled"
                                      [disabled]="isSaving"
                                      (ngModelChange)="onAttendanceConfigToggle()">
                    </mat-slide-toggle>
                  </div>
                  }
                  <div class="org-units-page__inheritance-banner"
                       [class.org-units-page__inheritance-banner--own]="isAttendanceConfigOwn">
                    <mat-icon>{{ isAttendanceConfigOwn ? 'tune' : 'account_tree' }}</mat-icon>
                    <div>
                      <span>{{ (isAttendanceConfigOwn ? 'operationalConfigInheritance.ownLabel' : 'operationalConfigInheritance.inheritedLabel') | translate }}</span>
                      <strong>{{ attendanceConfigOriginLabel }}</strong>
                      @if (!attendanceConfigForm.enabled) {
                      <small>{{ 'operationalConfigInheritance.enableToOverride' | translate }}</small>
                      }
                    </div>
                  </div>
                </div>
                <div class="row g-3 mb-2 org-work-assignment__fields">
                  <div class="col-12">
                    <mat-form-field subscriptSizing="dynamic"
                                    appearance="outline"
                                    style="width: 100%;">
                      <mat-label>{{ 'attendanceConfigsCatalog.fields.allowedSources' | translate }}</mat-label>
                      <mat-select [(ngModel)]="attendanceConfigForm.allowedSources"
                                  [disabled]="isSaving || !attendanceConfigForm.enabled || !canManageAttendanceConfig"
                                  (ngModelChange)="onAttendanceAllowedSourcesChange()"
                                  multiple>
                        @for (source of attendanceSourceOptions; track source) {
                        <mat-option [value]="source">{{ ('attendanceConfigsCatalog.sources.' + source) | translate }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div class="col-12">
                    <div class="org-detail__item h-100">
                      <span>{{ 'workAssignmentRules.enableAutoClose' | translate }}</span>
                      <div class="row g-3 mt-1 align-items-center">
                        <div class="col-12 col-lg-auto">
                          <mat-slide-toggle [(ngModel)]="attendanceConfigForm.turnPolicy.enableAutoClose"
                                            [disabled]="isSaving || !attendanceConfigForm.enabled || !canManageAttendanceConfig">
                            {{ 'workAssignmentRules.enableAutoClose' | translate }}
                          </mat-slide-toggle>
                        </div>
                        @if (attendanceConfigForm.turnPolicy.enableAutoClose) {
                        <div class="col-12 col-lg">
                          <mat-form-field subscriptSizing="dynamic"
                                          appearance="outline"
                                          style="width: 100%;">
                            <mat-label>{{ 'workAssignmentRules.autoCloseGraceMinutes' | translate }}</mat-label>
                            <input matInput
                                   type="number"
                                   min="0"
                                   step="1"
                                   [(ngModel)]="attendanceConfigForm.turnPolicy.autoCloseGraceMinutes"
                                   [disabled]="isSaving || !attendanceConfigForm.enabled || !canManageAttendanceConfig" />
                          </mat-form-field>
                        </div>
                        }
                      </div>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="org-detail__item h-100">
                      <span>{{ 'attendanceConfigsCatalog.sections.captureDefault' | translate }}</span>
                      <div class="row g-3 mt-1">
                        <div class="col-12 col-lg-6">
                          <mat-form-field subscriptSizing="dynamic"
                                          appearance="outline"
                                          style="width: 100%;">
                            <mat-label>{{ 'attendanceConfigsCatalog.fields.timezone' | translate }}</mat-label>
                            <mat-select [(ngModel)]="attendanceConfigForm.timezone"
                                        [disabled]="isSaving || !attendanceConfigForm.enabled || !canManageAttendanceConfig">
                              @for (timezone of attendanceTimezoneOptions; track timezone) {
                              <mat-option [value]="timezone">{{ timezone }}</mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </div>

                        <div class="col-12 col-lg-6">
                          <mat-form-field subscriptSizing="dynamic"
                                          appearance="outline"
                                          style="width: 100%;">
                            <mat-label>{{ 'attendanceConfigsCatalog.fields.duplicateWindowSeconds' | translate }}</mat-label>
                            <input matInput
                                   type="number"
                                   min="1"
                                   step="1"
                                   [(ngModel)]="attendanceConfigForm.duplicateWindowSeconds"
                                   [disabled]="isSaving || !attendanceConfigForm.enabled || !canManageAttendanceConfig" />
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="row g-2 mt-2">
                        <div class="col-12 col-md-6">
                          <mat-slide-toggle class="w-100"
                                            [(ngModel)]="attendanceConfigForm.requireGeo"
                                            [disabled]="isSaving || !attendanceConfigForm.enabled || !canManageAttendanceConfig">
                            {{ 'attendanceConfigsCatalog.fields.requireGeo' | translate }}
                          </mat-slide-toggle>
                        </div>
                        <div class="col-12 col-md-6">
                          <mat-slide-toggle class="w-100"
                                            [(ngModel)]="attendanceConfigForm.requireFaceEvidence"
                                            [disabled]="isSaving || !attendanceConfigForm.enabled || !canManageAttendanceConfig">
                            {{ 'attendanceConfigsCatalog.fields.requireFaceEvidence' | translate }}
                          </mat-slide-toggle>
                        </div>
                      </div>
                    </div>
                  </div>

                  @if (attendanceConfigForm.allowedSources.length > 0) {
                  <div class="col-12">
                    <div class="org-detail__item h-100">
                      <span>{{ 'attendanceConfigsCatalog.sections.sourceOverrides' | translate }}</span>
                      <div class="row g-3 mt-1">
                        @for (source of attendanceSourceRuleOptions; track source) {
                        @if (isAttendanceSourceEnabled(source)) {
                        <div class="col-12 col-md-6 col-xl-4">
                          <div class="org-detail__item h-100">
                            <span>{{ 'attendanceConfigsCatalog.sections.captureForSource' | translate:{ source: (getAttendanceSourceLabelKey(source) | translate) } }}</span>
                            <div class="d-flex align-items-center gap-2 mt-2">
                              <mat-slide-toggle [(ngModel)]="attendanceConfigForm.sourceRules[source].enabled"
                                                [disabled]="isSaving || !attendanceConfigForm.enabled || !canManageAttendanceConfig"
                                                (ngModelChange)="onAttendanceSourceRuleToggle(source)">
                                {{ 'attendanceConfigsCatalog.fields.customizeSource' | translate }}
                              </mat-slide-toggle>
                            </div>

                            @if (attendanceConfigForm.sourceRules[source].enabled) {
                            <div class="row g-3 mt-1">
                              @if (attendanceSourceUsesTimezone(source)) {
                              <div class="col-12">
                                <mat-form-field subscriptSizing="dynamic"
                                                appearance="outline">
                                  <mat-label>{{ 'attendanceConfigsCatalog.fields.timezone' | translate }}</mat-label>
                                  <mat-select [(ngModel)]="attendanceConfigForm.sourceRules[source].timezone"
                                              [disabled]="isSaving || !attendanceConfigForm.enabled || !canManageAttendanceConfig">
                                    @for (timezone of attendanceTimezoneOptions; track timezone) {
                                    <mat-option [value]="timezone">{{ timezone }}</mat-option>
                                    }
                                  </mat-select>
                                </mat-form-field>
                              </div>
                              }

                              @if (attendanceSourceUsesDuplicateWindow(source)) {
                              <div class="col-12">
                                <mat-form-field subscriptSizing="dynamic"
                                                appearance="outline">
                                  <mat-label>{{ 'attendanceConfigsCatalog.fields.duplicateWindowSeconds' | translate }}</mat-label>
                                  <input matInput
                                         type="number"
                                         inputmode="numeric"
                                         [(ngModel)]="attendanceConfigForm.sourceRules[source].duplicateWindowSeconds"
                                         [disabled]="isSaving || !attendanceConfigForm.enabled || !canManageAttendanceConfig" />
                                </mat-form-field>
                              </div>
                              }
                            </div>

                            @if (source !== 'device') {
                            <div class="row g-2 mt-2">
                              @if (attendanceSourceUsesGeo(source)) {
                              <div class="col-12 col-md-6">
                                <mat-slide-toggle class="w-100"
                                                  [(ngModel)]="attendanceConfigForm.sourceRules[source].requireGeo"
                                                  [disabled]="isSaving || !attendanceConfigForm.enabled || !canManageAttendanceConfig">
                                  {{ 'attendanceConfigsCatalog.fields.requireGeo' | translate }}
                                </mat-slide-toggle>
                              </div>
                              }
                              <div class="col-12 col-md-6">
                                <mat-slide-toggle class="w-100"
                                                  [(ngModel)]="attendanceConfigForm.sourceRules[source].requireFaceEvidence"
                                                  [disabled]="isSaving || !attendanceConfigForm.enabled || !canManageAttendanceConfig">
                                  {{ 'attendanceConfigsCatalog.fields.requireFaceEvidence' | translate }}
                                </mat-slide-toggle>
                              </div>
                              @if (attendanceSourceUsesDeviceRules(source)) {
                              <div class="col-12 col-md-6">
                                <mat-slide-toggle class="w-100"
                                                  [(ngModel)]="attendanceConfigForm.sourceRules[source].requireRegisteredDevice"
                                                  [disabled]="isSaving || !attendanceConfigForm.enabled || !canManageAttendanceConfig">
                                  {{ 'attendanceConfigsCatalog.fields.requireRegisteredDevice' | translate }}
                                </mat-slide-toggle>
                              </div>
                              <div class="col-12 col-md-6">
                                <mat-slide-toggle class="w-100"
                                                  [(ngModel)]="attendanceConfigForm.sourceRules[source].requireDeviceBinding"
                                                  [disabled]="isSaving || !attendanceConfigForm.enabled || !canManageAttendanceConfig">
                                  {{ 'attendanceConfigsCatalog.fields.requireDeviceBinding' | translate }}
                                </mat-slide-toggle>
                              </div>
                              }
                            </div>
                            }
                            } @else {
                            <strong class="mt-2 d-block">{{ 'attendanceConfigsCatalog.fields.inheritGeneralConfig' | translate }}</strong>
                            }
                          </div>
                        </div>
                        }
                        }
                      </div>
                    </div>
                  </div>
                  }

                  <div class="col-12">
                    <div class="org-detail__item h-100">
                      <span>{{ 'attendanceConfigsCatalog.sections.tracking' | translate }}</span>
                      <div class="row g-3 mt-1">
                        <div class="col-12 col-lg-6">
                          <mat-form-field subscriptSizing="dynamic"
                                          appearance="outline">
                            <mat-label>{{ 'attendanceConfigsCatalog.fields.trackingIntervalSeconds' | translate }}</mat-label>
                            <mat-select [(ngModel)]="attendanceConfigForm.trackingIntervalSeconds"
                                        [disabled]="isSaving || !attendanceConfigForm.enabled || !canManageAttendanceConfig">
                              @for (interval of attendanceTrackingIntervalOptions; track interval) {
                              <mat-option [value]="interval">{{ interval < 60 ? interval + ' s' : (interval / 60) + ' min' }}</mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <div class="col-12 col-lg-6">
                          <mat-form-field subscriptSizing="dynamic"
                                          appearance="outline"
                                          style="width: 100%;">
                            <mat-label>{{ 'attendanceConfigsCatalog.fields.allowedZones' | translate }}</mat-label>
                            <mat-select [(ngModel)]="attendanceConfigForm.allowedZoneIds"
                                        [disabled]="isSaving || !attendanceConfigForm.enabled || !canManageAttendanceConfig"
                                        multiple>
                              @for (zone of zoneOptions; track zone.zoneId) {
                              <mat-option [value]="zone.zoneId">{{ zone.name }}</mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="row g-2 mt-2">
                        <div class="col-12 col-md-4">
                          <mat-slide-toggle class="w-100"
                                            [(ngModel)]="attendanceConfigForm.trackable"
                                            [disabled]="isSaving || !attendanceConfigForm.enabled || !canManageAttendanceConfig">
                            {{ 'attendanceConfigsCatalog.fields.trackable' | translate }}
                          </mat-slide-toggle>
                        </div>
                        <div class="col-12 col-md-4">
                          <mat-slide-toggle class="w-100"
                                            [(ngModel)]="attendanceConfigForm.requireOnlineConnection"
                                            [disabled]="isSaving || !attendanceConfigForm.enabled || !canManageAttendanceConfig">
                            {{ 'attendanceConfigsCatalog.fields.requireOnlineConnection' | translate }}
                          </mat-slide-toggle>
                        </div>
                        <div class="col-12 col-md-4">
                          <mat-slide-toggle class="w-100"
                                            [(ngModel)]="attendanceConfigForm.allowOutOfZonePunch"
                                            [disabled]="isSaving || !attendanceConfigForm.enabled || !canManageAttendanceConfig">
                            {{ 'attendanceConfigsCatalog.fields.allowOutOfZonePunch' | translate }}
                          </mat-slide-toggle>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              } @else if (activeDetailTab === 'users' && isEditMode && selectedOrgUnit) {
              <div class="org-form__footer"
                   style="width: 100%; display: block;">
                @if (isLoadingUsers) {
                <app-loading-state [overlay]="false"
                                   [compact]="true"
                                   [message]="'orgUnitsCatalog.users.loading' | translate"></app-loading-state>
                } @else {
                <div class="row g-2 mb-2">
                  <div class="col-12 col-md-6">
                    <div class="org-detail__item h-100">
                      <span>{{ 'orgUnitsCatalog.users.allowTitle' | translate }}</span>
                      <strong>{{ allowUsers.length }}</strong>
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="org-detail__item h-100">
                      <span>{{ 'orgUnitsCatalog.users.denyTitle' | translate }}</span>
                      <strong>{{ denyUsers.length }}</strong>
                    </div>
                  </div>
                </div>

                @if (canUpdate) {
                <div class="card border-0 bg-light-subtle mb-2">
                  <div class="card-body p-2">
                    <div class="row g-2">
                      <div class="col-12 col-md-6">
                        <mat-form-field subscriptSizing="dynamic"
                                        appearance="outline"
                                        class="w-100">
                          <mat-label>{{ 'orgUnitsCatalog.users.addAllowLabel' | translate }}</mat-label>
                          <mat-select [(ngModel)]="selectedAllowUserId"
                                      [disabled]="isSavingUsers || !availableAllowUsers.length">
                            @for (user of availableAllowUsers; track trackByUser($index, user)) {
                            <mat-option [value]="user.uid">{{ user.displayName }} - {{ user.email }}</mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="col-12 col-md-6">
                        <mat-form-field subscriptSizing="dynamic"
                                        appearance="outline"
                                        class="w-100">
                          <mat-label>{{ 'orgUnitsCatalog.users.addDenyLabel' | translate }}</mat-label>
                          <mat-select [(ngModel)]="selectedDenyUserId"
                                      [disabled]="isSavingUsers || !availableDenyUsers.length">
                            @for (user of availableDenyUsers; track trackByUser($index, user)) {
                            <mat-option [value]="user.uid">{{ user.displayName }} - {{ user.email }}</mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="col-12 col-md-6 d-flex">
                        <button mat-flat-button
                                type="button"
                                class="btn-tone-primary w-100"
                                (click)="addSelectedUserToAllow()"
                                [disabled]="isSavingUsers || !selectedAllowUserId">
                          <mat-icon>how_to_reg</mat-icon>
                          {{ 'orgUnitsCatalog.users.addAllowAction' | translate }}
                        </button>
                      </div>
                      <div class="col-12 col-md-6 d-flex">
                        <button mat-stroked-button
                                type="button"
                                class="btn-tone-danger w-100"
                                (click)="addSelectedUserToDeny()"
                                [disabled]="isSavingUsers || !selectedDenyUserId">
                          <mat-icon>block</mat-icon>
                          {{ 'orgUnitsCatalog.users.addDenyAction' | translate }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                }

                <div class="row g-2">
                  <div class="col-12 col-lg-6">
                    <div class="card h-100 border">
                      <div class="card-body p-2">
                        <div class="d-flex align-items-center justify-content-between mb-2">
                          <h6 class="mb-0">{{ 'orgUnitsCatalog.users.allowTitle' | translate }}</h6>
                          <span class="badge text-bg-success">{{ allowUsers.length }}</span>
                        </div>

                        @if (allowUsers.length) {
                        <div class="list-group list-group-flush">
                          @for (user of allowUsers; track trackByUser($index, user)) {
                          <div class="list-group-item px-0 py-2">
                            <div class="d-flex justify-content-between align-items-start gap-2">
                              <div class="min-w-0">
                                <div class="fw-semibold">{{ user.displayName }}</div>
                                <div class="small text-muted">{{ user.email }}</div>
                                <div class="small text-muted">{{ getUserRolesLabel(user) }}</div>
                              </div>
                              @if (canUpdate) {
                              <button mat-icon-button
                                      type="button"
                                      (click)="removeUserFromAllow(user)"
                                      [disabled]="isSavingUsers"
                                      [attr.aria-label]="'orgUnitsCatalog.users.removeAllowAction' | translate">
                                <mat-icon>remove_circle_outline</mat-icon>
                              </button>
                              }
                            </div>
                          </div>
                          }
                        </div>
                        } @else {
                        <div class="small text-muted">{{ 'orgUnitsCatalog.users.emptyAllow' | translate }}</div>
                        }
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-lg-6">
                    <div class="card h-100 border">
                      <div class="card-body p-2">
                        <div class="d-flex align-items-center justify-content-between mb-2">
                          <h6 class="mb-0">{{ 'orgUnitsCatalog.users.denyTitle' | translate }}</h6>
                          <span class="badge text-bg-danger">{{ denyUsers.length }}</span>
                        </div>

                        @if (denyUsers.length) {
                        <div class="list-group list-group-flush">
                          @for (user of denyUsers; track trackByUser($index, user)) {
                          <div class="list-group-item px-0 py-2">
                            <div class="d-flex justify-content-between align-items-start gap-2">
                              <div class="min-w-0">
                                <div class="fw-semibold">{{ user.displayName }}</div>
                                <div class="small text-muted">{{ user.email }}</div>
                                <div class="small text-muted">{{ getUserRolesLabel(user) }}</div>
                              </div>
                              @if (canUpdate) {
                              <button mat-icon-button
                                      type="button"
                                      (click)="removeUserFromDeny(user)"
                                      [disabled]="isSavingUsers"
                                      [attr.aria-label]="'orgUnitsCatalog.users.removeDenyAction' | translate">
                                <mat-icon>remove_circle_outline</mat-icon>
                              </button>
                              }
                            </div>
                          </div>
                          }
                        </div>
                        } @else {
                        <div class="small text-muted">{{ 'orgUnitsCatalog.users.emptyDeny' | translate }}</div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                }
              </div>
              }
              }

              <!-- <div class="org-form__hint">
                {{ 'orgUnitsCatalog.hints.slug' | translate }}
              </div> -->

            </div>
            } @else if (selectedOrgUnit) {
            <div class="org-detail">
              <!-- <div class="org-detail__top">
                <span class="badge org-detail__level">{{ getLevelLabel(selectedOrgUnit.level) }}</span>
                <span class="badge"
                      [class.badge-solid-green]="selectedOrgUnit.isActive"
                      [class.badge-solid-red]="!selectedOrgUnit.isActive">
                  {{ getOrgUnitStatusLabel(selectedOrgUnit.isActive) }}
                </span>
              </div> -->
              <div class="org-detail__identity">
                <div class="org-detail__identity-icon">
                  <mat-icon>account_tree</mat-icon>
                </div>
                <div class="org-detail__identity-copy">
                  <h4 class="org-detail__name">{{ selectedOrgUnit.name }}</h4>
                  <p class="org-detail__type">{{ getNodeTypeLabel(selectedOrgUnit.type) }}</p>
                </div>
                <div class="org-detail__identity-meta">
                  <span class="org-detail__badge">{{ getLevelLabel(selectedOrgUnit.level) }}</span>
                  <span class="org-detail__badge"
                        [class.org-detail__badge--active]="selectedOrgUnit.isActive"
                        [class.org-detail__badge--inactive]="!selectedOrgUnit.isActive">
                    {{ getOrgUnitStatusLabel(selectedOrgUnit.isActive) }}
                  </span>
                </div>
              </div>

              @if (activeDetailTab === 'general') {
              <div class="org-detail__grid">
                <div class="org-detail__item">
                  <span>{{ 'orgUnitsCatalog.fields.company' | translate }}</span>
                  <strong>{{ selectedCompany?.name || 'N/D' }}</strong>
                </div>
                <div class="org-detail__item">
                  <span>{{ 'orgUnitsCatalog.fields.parentUnit' | translate }}</span>
                  <strong>{{ selectedOrgUnitParentName }}</strong>
                </div>
                <div class="org-detail__item">
                  <span>{{ 'orgUnitsCatalog.fields.directChildren' | translate }}</span>
                  <strong>{{ selectedOrgUnitChildrenCount }}</strong>
                </div>
                <div class="org-detail__item">
                  <span>{{ 'companiesRecordsCatalog.fields.code' | translate }}</span>
                  <strong>{{ selectedOrgUnitDetail?.code || 'N/D' }}</strong>
                </div>
              </div>
              } @else if (activeDetailTab === 'configuration') {
              @if (isLoadingDetail) {
              <app-loading-state [overlay]="false"
                                 [compact]="true"
                                 [message]="'orgUnitsCatalog.workAssignment.loading' | translate"></app-loading-state>
              } @else if (displayedWorkAssignment; as selectedWorkAssignment) {
              <div class="org-units-page__inheritance-banner"
                   [class.org-units-page__inheritance-banner--own]="isWorkAssignmentOwn">
                <mat-icon>{{ isWorkAssignmentOwn ? 'tune' : 'account_tree' }}</mat-icon>
                <div>
                  <span>{{ (isWorkAssignmentOwn ? 'operationalConfigInheritance.ownLabel' : 'operationalConfigInheritance.inheritedLabel') | translate }}</span>
                  <strong>{{ workAssignmentOriginLabel }}</strong>
                </div>
              </div>
              <div class="org-detail__grid">
                <div class="org-detail__item">
                  <span>{{ 'orgUnitsCatalog.workAssignment.workCycleId' | translate }}</span>
                  <strong>{{ selectedWorkCycleName }}</strong>
                </div>
                <div class="org-detail__item">
                  <span>{{ 'orgUnitsCatalog.workAssignment.restConfigurationId' | translate }}</span>
                  <strong>{{ selectedRestConfigurationName }}</strong>
                </div>
                <div class="org-detail__item">
                  <span>{{ 'orgUnitsCatalog.workAssignment.cycleStartDate' | translate }}</span>
                  <strong>{{ selectedWorkAssignment.cycleStartDate || '-' }}</strong>
                </div>
                <div class="org-detail__item">
                  <span>{{ 'orgUnitsCatalog.workAssignment.effectiveFrom' | translate }}</span>
                  <strong>{{ selectedWorkAssignment.effectiveFrom || '-' }}</strong>
                </div>
                <div class="org-detail__item">
                  <span>{{ 'orgUnitsCatalog.workAssignment.effectiveTo' | translate }}</span>
                  <strong>{{ selectedWorkAssignment.effectiveTo || ('orgUnitsCatalog.workAssignment.openEnded' | translate) }}</strong>
                </div>
              </div>

              <div class="employees-detail-page__section-card mt-3">
                <div class="employees-detail-page__section-header">
                  <h4>{{ 'workAssignmentRules.title' | translate }}</h4>
                  <p>{{ 'workAssignmentRules.description' | translate }}</p>
                </div>

                <div class="org-detail__grid">
                  <div class="org-detail__item">
                    <span>{{ 'workAssignmentRules.entryToleranceMinutes' | translate }}</span>
                    <strong>{{ selectedWorkAssignment.toleranceRules?.entryToleranceMinutes ?? '-' }}</strong>
                  </div>
                  <div class="org-detail__item">
                    <span>{{ 'workAssignmentRules.earlyExitToleranceMinutes' | translate }}</span>
                    <strong>{{ selectedWorkAssignment.toleranceRules?.earlyExitToleranceMinutes ?? '-' }}</strong>
                  </div>
                  <div class="org-detail__item">
                    <span>{{ 'workAssignmentRules.roundingMarginMinutes' | translate }}</span>
                    <strong>{{ selectedWorkAssignment.toleranceRules?.roundingMarginMinutes ?? '-' }}</strong>
                  </div>
                  <div class="org-detail__item">
                    <span>{{ 'workAssignmentRules.ignoreOvertime' | translate }}</span>
                    <strong>{{ selectedWorkAssignment.overtimePolicy?.ignoreOvertime ? ('common.yes' | translate) : ('common.no' | translate) }}</strong>
                  </div>
                </div>
              </div>
              } @else {
              <div class="org-empty-state org-empty-state--compact">
                <mat-icon>event_repeat</mat-icon>
                <h4>{{ 'orgUnitsCatalog.workAssignment.emptyTitle' | translate }}</h4>
                <p>{{ 'orgUnitsCatalog.workAssignment.emptyDescription' | translate }}</p>
              </div>
              }
              } @else if (activeDetailTab === 'devices') {
              @if (selectedDeviceIds.length) {
              <div class="org-detail__grid">
                @for (device of devices; track device.deviceId) {
                @if (selectedDeviceIds.includes(device.deviceId)) {
                <div class="org-detail__item">
                  <span>{{ device.serial || '-' }}</span>
                  <strong>{{ device.name || '-' }}</strong>
                </div>
                }
                }
              </div>
              } @else {
              <div class="org-empty-state org-empty-state--compact">
                <mat-icon>devices</mat-icon>
                <h4>{{ 'devicesCatalog.breadcrumb' | translate }}</h4>
                <p>{{ 'orgUnitsCatalog.devices.empty' | translate }}</p>
              </div>
              }
              } @else if (activeDetailTab === 'attendanceConfiguration' && canReadAttendanceConfig) {
              @if (isLoadingDetail) {
              <app-loading-state [overlay]="false"
                                 [compact]="true"
                                 [message]="'attendanceConfigsCatalog.loading' | translate"></app-loading-state>
              } @else if (displayedAttendanceConfig; as selectedAttendanceConfig) {
              <div class="org-units-page__inheritance-banner"
                   [class.org-units-page__inheritance-banner--own]="isAttendanceConfigOwn">
                <mat-icon>{{ isAttendanceConfigOwn ? 'tune' : 'account_tree' }}</mat-icon>
                <div>
                  <span>{{ (isAttendanceConfigOwn ? 'operationalConfigInheritance.ownLabel' : 'operationalConfigInheritance.inheritedLabel') | translate }}</span>
                  <strong>{{ attendanceConfigOriginLabel }}</strong>
                </div>
              </div>
              <div class="org-detail__grid">
                <div class="org-detail__item">
                  <span>{{ 'attendanceConfigsCatalog.fields.allowedSources' | translate }}</span>
                  <strong>{{ selectedAttendanceConfigSourcesLabel }}</strong>
                </div>
                <div class="org-detail__item">
                  <span>{{ 'attendanceConfigsCatalog.fields.timezone' | translate }}</span>
                  <strong>{{ selectedAttendanceConfig.attendanceCapture.timezone }}</strong>
                </div>
                <div class="org-detail__item">
                  <span>{{ 'attendanceConfigsCatalog.fields.duplicateWindowSeconds' | translate }}</span>
                  <strong>{{ selectedAttendanceConfig.attendanceCapture.duplicateWindowSeconds }}</strong>
                </div>
                <div class="org-detail__item">
                  <span>{{ 'attendanceConfigsCatalog.fields.allowedZones' | translate }}</span>
                  <strong>{{ selectedAttendanceConfigZonesLabel }}</strong>
                </div>
                <div class="org-detail__item">
                  <span>{{ 'attendanceConfigsCatalog.fields.trackable' | translate }}</span>
                  <strong>{{ selectedAttendanceConfig.tracking.trackable ? ('common.yes' | translate) : ('common.no' | translate) }}</strong>
                </div>
                <div class="org-detail__item">
                  <span>{{ 'attendanceConfigsCatalog.fields.requireGeo' | translate }}</span>
                  <strong>{{ selectedAttendanceConfig.attendanceCapture.requireGeo ? ('common.yes' | translate) : ('common.no' | translate) }}</strong>
                </div>
                <div class="org-detail__item">
                  <span>{{ 'attendanceConfigsCatalog.fields.requireFaceEvidence' | translate }}</span>
                  <strong>{{ selectedAttendanceConfig.attendanceCapture.requireFaceEvidence ? ('common.yes' | translate) : ('common.no' | translate) }}</strong>
                </div>
                <div class="org-detail__item">
                  <span>{{ 'attendanceConfigsCatalog.fields.trackingIntervalSeconds' | translate }}</span>
                  <strong>{{ selectedAttendanceTrackingIntervalLabel }}</strong>
                </div>
                <div class="org-detail__item">
                  <span>{{ 'attendanceConfigsCatalog.fields.requireOnlineConnection' | translate }}</span>
                  <strong>{{ selectedAttendanceConfig.tracking.requireOnlineConnection ? ('common.yes' | translate) : ('common.no' | translate) }}</strong>
                </div>
                <div class="org-detail__item">
                  <span>{{ 'attendanceConfigsCatalog.fields.allowOutOfZonePunch' | translate }}</span>
                  <strong>{{ selectedAttendanceConfig.zones.allowOutOfZonePunch ? ('common.yes' | translate) : ('common.no' | translate) }}</strong>
                </div>
                <div class="org-detail__item">
                  <span>{{ 'attendanceConfigsCatalog.fields.requireRegisteredDevice' | translate }}</span>
                  <strong>{{ selectedAttendanceConfig.deviceRules?.requireRegisteredDevice ? ('common.yes' | translate) : ('common.no' | translate) }}</strong>
                </div>
                <div class="org-detail__item">
                  <span>{{ 'attendanceConfigsCatalog.fields.requireDeviceBinding' | translate }}</span>
                  <strong>{{ selectedAttendanceConfig.deviceRules?.requireDeviceBinding ? ('common.yes' | translate) : ('common.no' | translate) }}</strong>
                </div>
                <div class="org-detail__item">
                  <span>{{ 'attendanceConfigsCatalog.fields.isActive' | translate }}</span>
                  <strong>{{ selectedAttendanceConfig.isActive !== false ? ('common.status.active' | translate) : ('common.status.inactive' | translate) }}</strong>
                </div>
                <div class="org-detail__item">
                  <span>{{ 'workAssignmentRules.enableAutoClose' | translate }}</span>
                  <strong>{{ selectedAttendanceConfig.turnPolicy?.enableAutoClose ? ('common.yes' | translate) : ('common.no' | translate) }}</strong>
                </div>
                @if (selectedAttendanceConfig.turnPolicy?.enableAutoClose) {
                <div class="org-detail__item">
                  <span>{{ 'workAssignmentRules.autoCloseGraceMinutes' | translate }}</span>
                  <strong>{{ selectedAttendanceConfig.turnPolicy?.autoCloseGraceMinutes ?? '-' }}</strong>
                </div>
                }
              </div>
              } @else {
              <div class="org-empty-state org-empty-state--compact">
                <mat-icon>pin</mat-icon>
                <h4>{{ 'attendanceConfigsCatalog.emptyTitle' | translate }}</h4>
                <p>{{ 'attendanceConfigsCatalog.emptyDescription' | translate }}</p>
              </div>
              }
              } @else {
              @if (activeDetailTab === 'users') {
              @if (isLoadingUsers) {
              <app-loading-state [overlay]="false"
                                 [compact]="true"
                                 [message]="'orgUnitsCatalog.users.loading' | translate"></app-loading-state>
              } @else {
              <div class="org-detail__grid mb-2">
                <div class="org-detail__item">
                  <span>{{ 'orgUnitsCatalog.users.allowTitle' | translate }}</span>
                  <strong>{{ allowUsers.length }}</strong>
                </div>
                <div class="org-detail__item">
                  <span>{{ 'orgUnitsCatalog.users.denyTitle' | translate }}</span>
                  <strong>{{ denyUsers.length }}</strong>
                </div>
              </div>

              @if (isEditMode && canUpdate) {
              <div class="card border-0 bg-light-subtle mb-2">
                <div class="card-body p-2">
                  <div class="row g-2">
                    <div class="col-12 col-md-6">
                      <mat-form-field subscriptSizing="dynamic"
                                      appearance="outline"
                                      class="w-100">
                        <mat-label>{{ 'orgUnitsCatalog.users.addAllowLabel' | translate }}</mat-label>
                        <mat-select [(ngModel)]="selectedAllowUserId"
                                    [disabled]="isSavingUsers || !availableAllowUsers.length">
                          @for (user of availableAllowUsers; track trackByUser($index, user)) {
                          <mat-option [value]="user.uid">{{ user.displayName }} - {{ user.email }}</mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="col-12 col-md-6">
                      <mat-form-field subscriptSizing="dynamic"
                                      appearance="outline"
                                      class="w-100">
                        <mat-label>{{ 'orgUnitsCatalog.users.addDenyLabel' | translate }}</mat-label>
                        <mat-select [(ngModel)]="selectedDenyUserId"
                                    [disabled]="isSavingUsers || !availableDenyUsers.length">
                          @for (user of availableDenyUsers; track trackByUser($index, user)) {
                          <mat-option [value]="user.uid">{{ user.displayName }} - {{ user.email }}</mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="col-12 d-flex flex-wrap gap-2">
                      <button mat-flat-button
                              type="button"
                              class="btn-tone-primary"
                              (click)="addSelectedUserToAllow()"
                              [disabled]="isSavingUsers || !selectedAllowUserId">
                        <mat-icon>how_to_reg</mat-icon>
                        {{ 'orgUnitsCatalog.users.addAllowAction' | translate }}
                      </button>
                      <button mat-stroked-button
                              type="button"
                              class="btn-tone-danger"
                              (click)="addSelectedUserToDeny()"
                              [disabled]="isSavingUsers || !selectedDenyUserId">
                        <mat-icon>block</mat-icon>
                        {{ 'orgUnitsCatalog.users.addDenyAction' | translate }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              }

              <div class="row g-2">
                <div class="col-12 col-lg-6">
                  <div class="card h-100 border">
                    <div class="card-body p-2">
                      <div class="d-flex align-items-center justify-content-between mb-2">
                        <h6 class="mb-0">{{ 'orgUnitsCatalog.users.allowTitle' | translate }}</h6>
                        <span class="badge text-bg-success">{{ allowUsers.length }}</span>
                      </div>

                      @if (allowUsers.length) {
                      <div class="list-group list-group-flush">
                        @for (user of allowUsers; track trackByUser($index, user)) {
                        <div class="list-group-item px-0 py-2">
                          <div class="d-flex justify-content-between align-items-start gap-2">
                            <div class="min-w-0">
                              <div class="fw-semibold">{{ user.displayName }}</div>
                              <div class="small text-muted">{{ user.email }}</div>
                              <div class="small text-muted">{{ getUserRolesLabel(user) }}</div>
                            </div>
                            @if (isEditMode && canUpdate) {
                            <button mat-icon-button
                                    type="button"
                                    (click)="removeUserFromAllow(user)"
                                    [disabled]="isSavingUsers"
                                    [attr.aria-label]="'orgUnitsCatalog.users.removeAllowAction' | translate">
                              <mat-icon>remove_circle_outline</mat-icon>
                            </button>
                            }
                          </div>
                        </div>
                        }
                      </div>
                      } @else {
                      <div class="small text-muted">{{ 'orgUnitsCatalog.users.emptyAllow' | translate }}</div>
                      }
                    </div>
                  </div>
                </div>

                <div class="col-12 col-lg-6">
                  <div class="card h-100 border">
                    <div class="card-body p-2">
                      <div class="d-flex align-items-center justify-content-between mb-2">
                        <h6 class="mb-0">{{ 'orgUnitsCatalog.users.denyTitle' | translate }}</h6>
                        <span class="badge text-bg-danger">{{ denyUsers.length }}</span>
                      </div>

                      @if (denyUsers.length) {
                      <div class="list-group list-group-flush">
                        @for (user of denyUsers; track trackByUser($index, user)) {
                        <div class="list-group-item px-0 py-2">
                          <div class="d-flex justify-content-between align-items-start gap-2">
                            <div class="min-w-0">
                              <div class="fw-semibold">{{ user.displayName }}</div>
                              <div class="small text-muted">{{ user.email }}</div>
                              <div class="small text-muted">{{ getUserRolesLabel(user) }}</div>
                            </div>
                            @if (isEditMode && canUpdate) {
                            <button mat-icon-button
                                    type="button"
                                    (click)="removeUserFromDeny(user)"
                                    [disabled]="isSavingUsers"
                                    [attr.aria-label]="'orgUnitsCatalog.users.removeDenyAction' | translate">
                              <mat-icon>remove_circle_outline</mat-icon>
                            </button>
                            }
                          </div>
                        </div>
                        }
                      </div>
                      } @else {
                      <div class="small text-muted">{{ 'orgUnitsCatalog.users.emptyDeny' | translate }}</div>
                      }
                    </div>
                  </div>
                </div>
              </div>
              }
              } @else {
              <div class="org-detail__mock-grid">
                <div class="org-form__group">
                  <mat-form-field subscriptSizing="dynamic"
                                  appearance="outline">
                    <mat-label>{{ 'orgUnitsCatalog.mock.roleWithAccess' | translate }}</mat-label>
                    <input matInput
                           [value]="'orgUnitsCatalog.mock.roleWithAccessValue' | translate" />
                  </mat-form-field>
                </div>
                <div class="org-form__group">
                  <mat-form-field subscriptSizing="dynamic"
                                  appearance="outline">
                    <mat-label>{{ 'orgUnitsCatalog.mock.mainPermission' | translate }}</mat-label>
                    <input matInput
                           value="orgUnits.update" />
                  </mat-form-field>
                </div>
                <div class="org-form__group">
                  <mat-form-field subscriptSizing="dynamic"
                                  appearance="outline">
                    <mat-label>{{ 'orgUnitsCatalog.mock.scope' | translate }}</mat-label>
                    <input matInput
                           [value]="'orgUnitsCatalog.mock.scopeValue' | translate" />
                  </mat-form-field>
                </div>
              </div>
              }
              }
            </div>
            } @else {
            <div class="org-empty-state org-empty-state--compact">
              <mat-icon>visibility</mat-icon>
              <h4>{{ 'orgUnitsCatalog.empty.noUnitTitle' | translate }}</h4>
              <p>{{ 'orgUnitsCatalog.empty.noUnitDescription' | translate }}</p>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<ng-template #treeNodeTemplate
             let-nodes>
  <div class="org-tree__level">
    @for (node of nodes; track trackByNode($index, node)) {
    <div class="org-tree__branch">
      <button type="button"
              class="org-tree__node"
              [class.org-tree__node--selected]="selectedOrgUnitId === node.orgUnitId"
              [class.org-tree__node--drop-target]="dragOverOrgUnitId === node.orgUnitId"
              [class.org-tree__node--dragging]="draggedOrgUnitId === node.orgUnitId"
              [draggable]="canUpdate"
              (dragstart)="handleDragStart(node)"
              (dragend)="handleDragEnd()"
              (dragover)="handleDragOverNode($event, node)"
              (drop)="handleDropOnNode($event, node)"
              (click)="selectOrgUnit(node)">
        <div class="org-tree__node-top">
          <div class="org-tree__node-main">
            @if (node.children.length) {
            <button type="button"
                    class="org-tree__toggle"
                    (click)="toggleNode(node, $event)">
              {{ isCollapsed(node) ? '+' : '-' }}
            </button>
            }
            <span class="org-tree__node-icon">
              <mat-icon>{{ getNodeIcon(node.type) }}</mat-icon>
            </span>
            <span class="org-tree__node-name">{{ node.name }}</span>
            @if (node.code) {
            <span class="org-tree__node-code">{{ node.code }}</span>
            }
          </div>
          <span class="org-tree__node-level">{{ getLevelLabel(node.level) }}</span>
        </div>
        <div class="org-tree__node-bottom">
          <div class="org-tree__node-meta">
            <span>{{ getNodeTypeLabel(node.type) }}</span>
          </div>
          <div class="org-tree__node-side">
            <span [class.text-success]="node.isActive"
                  [class.text-danger]="!node.isActive">
              {{ getOrgUnitStatusLabel(node.isActive) }}
            </span>
          </div>
        </div>
      </button>

      @if (node.children.length && !isCollapsed(node)) {
      <div class="org-tree__children">
        <ng-container *ngTemplateOutlet="treeNodeTemplate; context: { $implicit: node.children }"></ng-container>
      </div>
      }
    </div>
    }
  </div>
</ng-template>
